export default function qrCodeCampaignsReducer(state = {
  campaigns: [],
  campaign: {},
  groups: [],
  abmCodes: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_QR_CODE_CAMPAIGNS_PENDING':
    case 'GET_QR_CODE_CAMPAIGN_PENDING':
    case 'GET_QR_CODE_CAMPAIGN_META_PENDING': {
      return { ...state, fetching: true, fetched: false };
    }
    case 'GET_QR_CODE_CAMPAIGN_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        campaign: action.payLoad.data
      };
    }
    case 'GET_QR_CODE_CAMPAIGNS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        campaigns: action.payLoad.data
      };
    }
    case 'GET_QR_CODE_CAMPAIGN_META_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        groups: action.payLoad.meta.groups,
        abmCodes: action.payLoad.meta.abm_codes
      };
    }
    case 'GET_QR_CODE_CAMPAIGNS_REJECTED':
    case 'GET_QR_CODE_CAMPAIGN_REJECTED':
    case 'GET_QR_CODE_CAMPAIGN_META_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payLoad
      };
    }
    default:
      return state;
  }
}
